import { render, staticRenderFns } from "./grandShine.vue?vue&type=template&id=28396d88&scoped=true"
import script from "./grandShine.vue?vue&type=script&lang=js"
export * from "./grandShine.vue?vue&type=script&lang=js"
import style0 from "./grandShine.vue?vue&type=style&index=0&id=28396d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28396d88",
  null
  
)

export default component.exports